'use strict';

function LoanOfferReupLicence() {
  this.extends = [_Paths];
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this._hist = new History();

  this.init = function () {};

  this.initAllReady = function () {
    setTimeout($.proxy(this._catchInvalidRequest, this), 1);
    this.analytics.pushEvent('virtual-page-view');
  };

  this._catchInvalidRequest = function () {
    this._navTray = $('#tray-navigation').mogo();

    if (!this._navTray.isCompleted(0)) {
      this._hist.goToUrl(this.paths.loans.offer_refresh_review_info);
    } else if (!this._navTray.isCompleted(1)) {
      this._hist.goToUrl(this.paths.loans.offer_refresh_select_amount);
    }
  };
}